module.exports = __webpack_public_path__ + "static/media/logo_black.8b0183f4.png";